<template>
  <div class="image-modal" v-if="isOpen" @click="close()">
    <!-- 弹窗内容 -->
    <img :src="imageUrl" alt="Static Image">
  </div>
</template>


<script>
  export default {
    name: 'PreviewModal',
    data() {
      return {
        isOpen: false, // 控制弹窗显示与否
        imageUrl: '' // 存放图片URL地址
      }
    },
    methods: {
      show(url) {
        this.isOpen = true
        this.imageUrl = url
        // 禁止页面滚动
        document.body.style.overflowY = 'hidden'
      },
      close() {
        this.isOpen = false
        // 重新开放页面滚动
        document.body.style.overflowY = ''
      }
    }
  }
</script>

<style scoped>
/* 自定义样式 */
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 设置背景色及透明度 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.image-modal img {
  max-width: 80%;
  max-height: 80%;
}

.image-modal button {
  margin-top: 20px;
}
</style>
